import React, { useContext, useEffect, useState } from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { IoWarning } from "react-icons/io5";
import { Link, useParams } from "react-router-dom";
import ClientAuthContext from "../../context/ClientAuthContext";
import { serverInstance } from "../../service/axios";
import "./book.scss";

class BookModel {
  id
  title
  description
  year
  authors
  keywords
  fileUrl
}

const Book= ({ data }) => {
  const params = useParams();
  const { userData } = useContext(ClientAuthContext)
  const [isMembershipActive, setMembershipActive] = useState(false);
  const [book, setBook] = useState(new BookModel());
  const [chapters, setChapters] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setMembershipActive(userData?.paid_until && new Date(userData.paid_until) > new Date());
  }, [userData]);

  useEffect(() => {
    if (params.id && !book.fileUrl) {
      getBook();
      getChapters(params.id);
    }
  }, [params.id]);

  const getBook = () => {
    serverInstance.post("/app/item", { class: "book", id: params.id }, {
      headers: {
        "Content-Type": "application/json",
      }
    })
    .then(res => {
      res.data.item.fileUrl = `https://msid-asset.s3.ap-northeast-2.amazonaws.com/${res.data.item.fileUrl}`;
      setBook(res.data.item)
      setLoading(false);
      setErrorMsg("");
    })
    .catch((err) => {
      setLoading(false);
      setErrorMsg(err);
    })
  }

  const getChapters = (book_id) => {
    serverInstance.get("/app/chapters?book_id=" + book_id)
      .then(res => {
        setChapters(res.data.items.sort((a, b) => a.order - b.order))
      })
      .catch((err) => {
        setErrorMsg(err);
      })
  }

  return (
    <div className="book">
      {loading ? <>
        <AiOutlineLoading3Quarters size={25} className="loading-spinner"/>
      </>
      :
      <>
        {errorMsg ?
        <div className="error-msg">
          <IoWarning/>
          &nbsp;
          {errorMsg}
        </div>: null}

        <section className="book-main">
          <div className="book-left">
            <div className="title">{book.title}</div>
            <div className="author">
              {data.author}:<br/>
              <span className="author-name">{book?.authors?.join(", ")}</span>
            </div>
            <div className="book-cover">
              <div className="cover">
                <img src={book.fileUrl}/>
              </div>
              <div className="book-info">
                { isMembershipActive ? null :
                  <div className="payment">
                    {data.payment}
                  </div>
                }
                <div className="">
                  <strong>{data.summary}</strong>
                  :<br/> {book.description}
                </div>
                <div className="info-row">
                  <strong>{data.year}</strong>
                  :<br/> {book?.year}
                </div>
                {/* <div className="info-row">
                  <strong>{data.keyword}</strong>
                  :<br/> {book?.keywords?.join(", ")}
                </div> */}
              </div>
            </div>
          </div>

          <div className="book-right">
          { isMembershipActive ?
            <div className="chapters">
              <div className="chapter-title">
                {data.chapters}
              </div>
              {chapters.map((chapter, index) => {
                return (
                  <div key={index} className="chapter">
                    <Link target="_blank" to={`/chapter/${chapter.id}`}>{chapter.title}</Link>
                  </div>
                )
              })}
            </div>
            : null
          }
          </div>
        </section>
      </>}
    </div>
  );
}

export default Book;